module.exports = __webpack_public_path__ + "static/media/error-page.4232de16.png";